<i18n>
{
  "en": {
    "label": "Around me",
    "error": {
      "generic": "Unable to find your position",
      "permissionDenied": "Please allow geolocation."
    }
  },
  "fr": {
    "label": "Autour de moi",
    "error": {
      "generic": "Géolocalisation impossible.",
      "permissionDenied": "Veuillez autoriser la géolocalisation."
    }
  },
  "de": {
    "label": "Um mich herum",
    "error": {
      "generic": "Geolokalisierung unmöglich.",
      "permissionDenied": "Bitte erlauben Sie die Geolokalisierung."
    }
  }
}
</i18n>

<template>
  <button
    type="button"
    class="store-locator-around-me base-btn base-btn--primary"
    @click="getPosition"
  >
    {{ $t('label') }}
    <span class="icon icon--marker"></span>
  </button>
</template>

<script>
import { getUserPosition } from '../utils/Geolocation';

export default {
  name: 'StoreLocatorAroundMe',
  methods: {
    getPosition() {
      getUserPosition()
        .then(({ coords: { latitude, longitude } }) => {
          this.$emit('click', { latitude, longitude });
        })
        .catch((error) => {
          alert(
            this.$t(
              `error.${
                error.code === error.PERMISSION_DENIED
                  ? 'permissionDenied'
                  : 'generic'
              }`
            )
          );
        });
    },
  },
};
</script>
